import {
  InvoiceGeneralFormValues,
  TypeOfTaxpayers,
} from '@/core/domain/invoice/invoice/Invoice.types';
import { Col, Form, Row, Select } from 'antd';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import SelectRecipientType from '../../../InvoiceForms/InvoiceRecipientForm/RecipientForm/SelectRecipientType';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { FloatingFormItem } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import SelectYesNo from '@/components/_common/SelectYesNo';

const InvoiceStepRecipient: React.FC = () => {
  const intl = useIntl().formatMessage;
  const form = Form.useFormInstance<InvoiceGeneralFormValues>();

  const ruleRequired = useDefaultEmptyFieldError();

  const invoiceType = Form.useWatch('invoiceType', form);

  const isNfc = invoiceType === InvoiceType.NFC;
  const isNfs = invoiceType === InvoiceType.NFS;

  const cpfCnpj = Form.useWatch(['recipient', 'cpfCnpj'], form);

  useEffect(() => {
    if (cpfCnpj) {
      form.setFieldValue(
        'finalConsumer',
        cpfCnpj.length > 11 ? 'true' : 'false',
      );
    }
  }, [cpfCnpj]);

  const typeOfTaxpayersOptions = [
    {
      label: intl({
        id: 'invoice.nfe.recipient.form.typeOfTaxpayers.contributorIcms',
      }),
      value: TypeOfTaxpayers.icmsTaxPayer,
    },
    {
      label: intl({
        id: 'invoice.nfe.recipient.form.typeOfTaxpayers.contributorExempt',
      }),
      value: TypeOfTaxpayers.exemptTaxPayer,
    },
    {
      label: intl({
        id: 'invoice.nfe.recipient.form.typeOfTaxpayers.nonTaxpayer',
      }),
      value: TypeOfTaxpayers.nonContributor,
    },
  ];

  return (
    <>
      <Row gutter={[16, 16]}>
        <SelectRecipientType form={form} />

        {invoiceType !== InvoiceType.NFS && (
          <>
            <Col span={24} md={12} xl={6}>
              <FloatingFormItem
                label={intl({
                  id: 'invoice.nfe.recipient.form.typeOfTaxpayers',
                })}
                name={'taxpayerType'}
                rules={!isNfc ? [ruleRequired] : []}
                initialValue={
                  !isNfc ? TypeOfTaxpayers.nonContributor : undefined
                }
              >
                <Select options={typeOfTaxpayersOptions} allowClear={isNfc} />
              </FloatingFormItem>
            </Col>
          </>
        )}

        {!isNfs && (
          <Col span={24} md={12} lg={6}>
            <FloatingFormItem
              label={intl({ id: 'invoice.domain.finalCostumer' })}
              name="finalConsumer"
              rules={!isNfc ? [ruleRequired] : []}
              initialValue={!isNfc ? 'true' : undefined}
            >
              <SelectYesNo allowClear />
            </FloatingFormItem>
          </Col>
        )}
      </Row>
    </>
  );
};

export default InvoiceStepRecipient;
